import React from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import FooterLesson from "./FooterLesson";
import ContentMessage from "./ContentMessage";
import LessonView from "./LessonView";
import ContentProject from "../project/ContentProject";
import HeaderProject from "../project/HeaderProject";
import useCourseContent from "../../../../hooks/useCourseContent";
import {useAuth} from "../../../../context/AuthProvider";

/**
 * Entry point for a course content item.
 * Fetches the content, then delegates rendering based on its type.
 */
const CourseContent = () => {
    const {course_id, content_id} = useParams();
    const navigate = useNavigate();
    const {user} = useAuth();
    const [searchParams] = useSearchParams();
    const currentLanguage = searchParams.get("language") || "FARSI";

    const {content, contentType, alreadyCompleted, loading, error} = useCourseContent(
        course_id,
        content_id,
        currentLanguage
    );

    // TODO: id of the started lesson attempt (created when the lesson opens)
    const lessonAttemptId = null;

    if (loading) {
        return <ContentMessage message="در حال بارگذاری..."/>;
    }

    if (error) {
        return <ContentMessage message={error}/>;
    }

    switch (contentType) {
        case "lesson":
            // `key` resets lesson progress when navigating to another content item
            // onExit: where to go after the completion screen (replace with your course route)
            return (
                <LessonView
                    key={content_id}
                    content={content}
                    userId={user?.id}
                    courseId={course_id}
                    contentId={content_id}
                    lessonAttemptId={lessonAttemptId}
                    alreadyCompleted={alreadyCompleted}
                    onExit={() => navigate(-1)}
                />
            );

        case "project":
            return (
                <div className="min-h-screen flex flex-col">
                    <HeaderProject/>
                    <main className="flex-1 w-full">
                        <ContentProject content={content}/>
                    </main>
                </div>
            );

        case "video":
            return (
                <ContentMessage
                    header={<HeaderProject/>}
                    footer={<FooterLesson/>}
                    message="ویدیو به‌زودی اضافه می‌شود."
                />
            );

        default:
            return <ContentMessage message="نوع محتوا پشتیبانی نمی‌شود."/>;
    }
};

export default CourseContent;